export const DOMAIN_DEMO_NAME = 'gifts.dev.eboxenterprises.com';
export const DOMAIN_DEMO_NAME1 = 'ratechapp.dev.eboxenterprises.com';
export const DOMAIN_DEMO_NAME_API = '148.113.193.136:20443';
export const DOMAIN_DEMO_API = 'http://'+DOMAIN_DEMO_NAME_API;
